import Subject from 'common/src/utils/pubsub/subject';

const clientSettingsValuesPromise: {current: Promise<Map<string, string>> | null} = {
  current: null,
};

const clientSettingsValuesSubject = new Subject<Map<string, string> | null>(null);

export {clientSettingsValuesPromise, clientSettingsValuesSubject};
